(function() {
    angular
        .module('rlt')
        .controller('ExcludeResponsesCtrl', ExcludeResponsesCtrl );

    ExcludeResponsesCtrl.$inject = [
        'DataDrivenDialogService'
    ];

    function ExcludeResponsesCtrl( DataDrivenDialogService ) {
        
        var vm = this;
        vm.onSubmit = onSubmit;
        vm.excludeDialog = DataDrivenDialogService.register( 'ExcludeResponses' );
        vm.selectedResponses = [];


        function onSubmit() {
            var result = [];
            vm.selectedResponses.forEach( function( yesno, id ) {
                if( yesno ) {
                    result.push( id );
                }
            });

            DataDrivenDialogService.onSubmit('ExcludeResponses', result );
        }
    }
        
})();



